"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var card_1 = __importDefault(require("~/components/blog/blog_comment_list/card"));
var BlogCommentList = function (_a) {
    var blogComments = _a.blogComments;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "blogComment-CommentList" }, blogComments.map(function (comment, idx) { return (react_1.default.createElement(card_1.default, { key: idx, comment: comment })); }))));
};
exports.default = BlogCommentList;
